<div *ngIf="!isButton" class="send-box" (click)="onOpen()">
   <span>Enviar</span>
</div>

<div *ngIf="isButton">
    <button class="btn btn-primary" type="button" (click)="onOpen()" style="width: 200px">
        Enviar
    </button>
</div>


<ng-template #sendGiviModal let-modal>
    <div class="modal-body">

        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="m-b-20 border-bottom">
            <div class="text-center">
                <i class="mdi mdi-send mdi-24px"></i>
            </div>
            <div class="text-center m-b-20">
                Enviar Givi
            </div>
        </div>

        <div class="m-b-20">

            <!--Vendor -->
            <div class="p-t-10 p-b-10 m-b-20">
                <!--Product Name -->
                <div class="text-center font-bold font-16 m-b-10">
                    <span *ngIf="givi.product">{{givi.product?.name}}</span>
                    <span *ngIf="givi.giftcard">{{givi.giftcard?.name}}</span>
                </div>
                <!--Vendor Name -->
                <div class="text-center m-b-10">
                    <app-img-round [src]="givi.vendor?.logoURL" [width]="48"></app-img-round>
                    {{givi.vendor?.name}}
                </div>
                <!--Store Names -->
                <app-smart-list-store [stores]="vendorStores"></app-smart-list-store>
            </div>

            <div class="m-b-20" style="clear: both;">
                1. Podés enviar el regalo por cualquier red social con sólo enviar el link
            </div>

            <div class="m-b-20">
                <img src="assets/images/redesSociales.png" width="300">
            </div>

            <div class="m-b-20">
                2. Cuando la persona lo abra y lo agregue a sus Givis, automáticamente desaparecerá de tu cuenta
            </div>

            <div class="m-b-20">
                <input id="givi-link" class="w-100 font-12" readonly="true" [value]="givilink">

                <label *ngIf="linkCopied" class="text-primary font-11">Link Copiado</label>
            </div>
        </div>

        <div class="d-flex-center m-b-40">
            <button type="button" class="btn btn-outline-primary btn-wmd" (click)="onCopyLink()">Copiar Link</button>
        </div>
    </div>
</ng-template>
